import { render } from "./Generator.vue?vue&type=template&id=36953f7e"
import script from "./Generator.vue?vue&type=script&lang=js"
export * from "./Generator.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__